import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { SpecialCharacters } from 'src/app/core/enums';
import { UserAdmin } from 'src/app/core/models/admin/user-admin.model';
import { UserService } from 'src/app/core/services/admin/user/user.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { LocationPermissionUtils } from 'src/app/core/utils/permissions/location-permissions/location-permissions.utils';
import {
  CONSTS,
  CUSTOMER_SCAN_TYPE_OPTIONS,
  CUSTOMER_TYPE_OPTIONS,
  CUSTOMER_VALIDATION_TYPE_OPTIONS,
} from './top-section.constants';

@Component({
  selector: 'app-top-section',
  templateUrl: './top-section.component.html',
  styleUrl: './top-section.component.scss',
  standalone: false,
})
export class TopSectionComponent implements OnInit {
  @Input({ required: true }) form!: FormGroup;

  readonly userService = inject(UserService);
  private readonly destroy = inject(DestroyRef);
  private readonly locPermisisons = inject(LocationPermissionUtils);
  readonly commonUtils = inject(CommonUtils);

  currUser!: UserAdmin;

  readonly CONSTANTS = CONSTS;
  readonly CUSTOMER_SCAN_TYPES = CUSTOMER_SCAN_TYPE_OPTIONS;
  readonly CUSTOMER_VALIDATION_TYPES = CUSTOMER_VALIDATION_TYPE_OPTIONS;
  readonly CUSTOMER_TYPES = CUSTOMER_TYPE_OPTIONS;
  readonly SpecialCharacters = SpecialCharacters;

  ngOnInit(): void {
    this.userService
      .getCurrentUser$()
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe((val) => {
        this.currUser = val;
      });
  }

  get canSeeThresholds() {
    return this.locPermisisons.canEditThresholdProperties(
      this.currUser.roleName,
    );
  }
}
